import React, { useEffect, useState } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Title from './title';
import Content from './content';
import Comment from './comment';
// import Recommed from './recommed';
import UserInfo from '@src/mobile/components/userInfo';
import Brand from '@src/mobile/components/brand';
import Status from '@src/mobile/components/status';
import styles from './index.css';
import { type FeedFlowItem } from '@src/services/interface';
import { newApi, getQuery } from '@src/utils';
import SecondShare from './secondShare';
import { volcengineAndH5Statistics } from '@ifeng-fe/mobile_statistics';

type AllData = {
    content: {
        pageId: string;
    };
};

type PageStatus = 'contentReview' | 'contentOffline' | 'contentFail' | 'contentOk' | 'contentLoading';

const Layout = ({ content }: AllData) => {
    const pageId = content.pageId || '';
    const [detail, setDetail] = useState<FeedFlowItem | null>(null);
    const [pageStatus, setPageStatus] = useState<PageStatus>(pageId ? 'contentLoading' : 'contentFail');
    const userId = getQuery(window.location.href, 'userId') || '';

    useEffect(() => {
        const getDetail = async () => {
            try {
                const result = await newApi.feed.detailDetail(pageId);
                const resultData = result?.data?.data;

                if (resultData) {
                    const useFlag = resultData.useFlag ?? -1;
                    const state = resultData.state ?? 0;

                    if (useFlag == 1 && state == 1) {
                        setPageStatus('contentOk');
                        setDetail(resultData);
                        console.log(resultData, '页面数据');
                    }
                    if (useFlag == 1 && state == -1) {
                        setPageStatus('contentReview');
                    }
                    if (useFlag != 1 || state == 0) {
                        setPageStatus('contentOffline');
                    }
                } else {
                    setPageStatus('contentFail');
                }
            } catch (e) {
                setPageStatus('contentFail');
                console.error(e);
            }
        };
        getDetail();
        const id = `tweet_${pageId}`;

        // 此统计已兼容page双发的功能，但这个示例不能合并成一个方法进行发送，因为发送的值并不统一
        volcengineAndH5Statistics({
            behavior: 'page',
            type: 'sharepage_expose',
            sharepage_type: 'a',
            id,
            user_id: userId,
        });
        volcengineAndH5Statistics({
            environment: 'h5',
            behavior: 'page',
            id,
            type: 'tweet',
            url: window.location.href,
        });
    }, [userId, pageId]);

    const userInfoData = {
        author: detail?.author,
        location: detail?.location,
        ipLocation: detail?.ipLocation,
        ctime: detail?.ctime,
        callAppData: {
            docType: 'flutter',
            pid: `/detail?id=${pageId}&ref=outside`,
            kind: 'inter_txs01',
            noKindFrom: 1,
            download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1369929210351',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8987',
        },
    };

    const brandData = {
        callAppData: {
            docType: 'flutter',
            pid: `/detail?id=${pageId}&ref=outside`,
            kind: 'inter_txs22',
            noKindFrom: 1,
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1531161828752',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9042',
        },
        statData: {
            behavior: 'action',
            type: 'sharepage_app_start',
            button_name: 'o',
            user_id: userId,
            id: `tweet_${pageId}`,
        },
    };
    const commentData = {
        pageId,
        doc_url: `tweet_${pageId}`,
        user_id: detail?.author?.guid,
    };

    return (
        <div className={styles.layout}>
            {pageStatus === 'contentOk' ? (
                <>
                    <Title content={detail?.title} />
                    <UserInfo content={userInfoData} />
                    <Content content={detail} />
                    <Comment content={commentData} />
                    <Brand content={brandData} />
                </>
            ) : (
                <Status content={pageStatus} />
            )}
            <SecondShare content={detail} />
        </div>
    );
};

export default errorBoundary(Layout);
